import { useSelector } from "react-redux";

import SyntaxAnalysisPage from "../../analysis/syntax_analysis/SyntaxAnalysisPage";
import { getContentHeight } from "../../../../../utils/textUtils";
import "./BookSyntaxPage.css";

// 리더스북 · 파닉스북 구문분석(2026-10-20 대표: "리더스 · 파닉스 교재처럼"). 고르기 · 채점 · 저장은 지문분석 구문분석
// 화면을 그대로 쓰고(재구축 금지), 겉모습만 ECHO 교재 쪽처럼 입힌다:
// 쪽 머리띠(Unit · 책 이름 · 활동) → 두 색 제목 → 동그라미 글자(A) 달린 활동 띠 → 문장 → 낱말 칩 같은 성분 단추(S · V · O 동그라미).
// 꾸밈은 BookSyntaxPage.css 가 .book-syntax 아래에서만 건다(지문분석 구문분석은 그대로).
const DEFAULT_ACCENT = "#D6336C";

const BookSyntaxPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { assignment, section } = useSelector((state) => state.assignment);
  const book = section?.question?.book || {};
  const accent = book.theme_color || DEFAULT_ACCENT;
  // 과제 이름이 'Ginedu Phonics · Unit 01 · Tap, Tap, Tap!' 꼴이면 Unit 칸을 머리띠에 쓴다
  const unitLabel = String(assignment?.title || "").split(" · ").find((part) => /^(Unit|Starter)/.test(part)) || "";

  return (
    <div className="book-syntax" style={{ height: getContentHeight(), "--book-accent": accent }}>
      <div className="book-syntax__band">
        {[unitLabel, book.title, "Sentence Check"].filter(Boolean).join(" · ")}
      </div>
      <div className="book-syntax__head">
        <h2>
          <em>Sentence</em> Check
        </h2>
        {book.picture_url ? <img className="book-syntax__picture" src={book.picture_url} alt="" /> : null}
      </div>
      <div className="book-syntax__section">
        <i>A</i>
        <span>Read and find. 표시된 말이 문장에서 무슨 역할인지 골라요.</span>
      </div>
      <div className="book-syntax__body">
        <SyntaxAnalysisPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} showStepsBar={false} />
      </div>
    </div>
  );
};

export default BookSyntaxPage;
